import { useEffect } from 'react';

const useGA = (userId: string | number, isLoggedIn: boolean) => {
  useEffect(() => {
    if (userId) {
      try {
        window.g_user_id = userId;
        window.g_user_auth = isLoggedIn;
      } catch (e) {
        console.warn(e);
      }
    }
  }, [userId, isLoggedIn]);
};

export default useGA;
